// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import StyledLoginFormContainer from "./StyledLoginFormContainer-APP_CLIENT.styled";

export default StyledLoginFormContainer;
